export default __webpack_public_path__ + "static/media/nft-sample.edf4ddba.jpeg";